var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", { attrs: { tabindex: "-1" } }, [
      _vm._v(
        "\n    " +
          _vm._s(_vm.$t("ContinuousReport.Collaboration.Title")) +
          "\n  "
      )
    ]),
    _vm._v(" "),
    _vm.collaboration
      ? _c(
          "div",
          [
            _c(
              "h3",
              { staticClass: "mt-0" },
              [
                _c("plain-text-control", {
                  attrs: {
                    title: "SummaryReport.Collaboration.Volunteers.Title"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _vm.collaboration.volunteerSummary.computedCount == null
              ? _c("div", [
                  _c("span", { staticClass: "font-italic" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "ContinuousReportSummary.Collaboration.Volunteers.NoVolunteers"
                        )
                      )
                    )
                  ])
                ])
              : [
                  _c("text-label-row", {
                    attrs: {
                      title:
                        "ContinuousReportSummary.Collaboration.Volunteers.ComputedCount",
                      value: _vm.$t(
                        "ContinuousReportSummary.Collaboration.Volunteers.ComputedCountValue",
                        [_vm.collaboration.volunteerSummary.computedCount]
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c("numeric-input-row", {
                    attrs: {
                      title:
                        "ContinuousReportSummary.Collaboration.Volunteers.RevisedCount",
                      id: "revisedVolunteerCount",
                      required: ""
                    },
                    model: {
                      value: _vm.collaboration.volunteerSummary.revisedCount,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.collaboration.volunteerSummary,
                          "revisedCount",
                          $$v
                        )
                      },
                      expression: "collaboration.volunteerSummary.revisedCount"
                    }
                  }),
                  _vm._v(" "),
                  _vm.hasTargets
                    ? _c("check-box-dialog-row", {
                        attrs: {
                          id: "targetsDialog",
                          title:
                            "ContinuousReportSummary.Collaboration.Volunteers.Targets",
                          buttonLabel: "ContinuousReport.Button.SelectTarget",
                          displayOptionNames: false,
                          options: _vm.targets,
                          required: ""
                        },
                        model: {
                          value: _vm.collaboration.volunteerSummary.targets,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.collaboration.volunteerSummary,
                              "targets",
                              $$v
                            )
                          },
                          expression: "collaboration.volunteerSummary.targets"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("text-area-with-notes-control", {
                    attrs: {
                      id: "volunteertaskdescription",
                      required: "",
                      title:
                        "ContinuousReportSummary.Collaboration.Volunteers.TaskDescription",
                      notes: _vm.notesReference,
                      "max-length": 500,
                      rows: 5,
                      buttonTooltip:
                        "ContinuousReportSummary.Collaboration.Volunteers.TaskDescription_NotesTooltip"
                    },
                    model: {
                      value: _vm.collaboration.volunteerSummary.taskDescription,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.collaboration.volunteerSummary,
                          "taskDescription",
                          $$v
                        )
                      },
                      expression:
                        "collaboration.volunteerSummary.taskDescription"
                    }
                  })
                ],
            _vm._v(" "),
            _c(
              "h3",
              [
                _c("plain-text-control", {
                  attrs: {
                    title:
                      "ContinuousReportSummary.Collaboration.Partners.Title"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            !_vm.collaboration.partners ||
            _vm.collaboration.partners.length === 0
              ? _c("div", { staticClass: "mb-4" }, [
                  _c("span", { staticClass: "font-italic" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "ContinuousReportSummary.Collaboration.Partners.NoPartners"
                        )
                      )
                    )
                  ])
                ])
              : [
                  _c("partners-control", {
                    attrs: {
                      model: _vm.collaboration,
                      targets: _vm.targets,
                      targetGroups: _vm.targetGroups
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "h3",
                    [
                      _c("plain-text-control", {
                        attrs: {
                          title:
                            "ContinuousReportSummary.Collaboration.CustomerGuidance.Title"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.collaboration.customerGuidanceSummary.computedTotals ||
                  _vm.collaboration.customerGuidanceSummary.computedTotals
                    .length === 0
                    ? _c("div", { staticClass: "mb-4" }, [
                        _c("span", { staticClass: "font-italic" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "ContinuousReportSummary.Collaboration.CustomerGuidance.NoCustomerGuidance"
                              )
                            )
                          )
                        ])
                      ])
                    : [
                        _c("customer-guidance-tables-control", {
                          staticClass: "mb-2",
                          attrs: {
                            totals:
                              _vm.collaboration.customerGuidanceSummary
                                .computedTotals,
                            title:
                              "ContinuousReportSummary.Collaboration.CustomerGuidance.ComputedTotals"
                          }
                        }),
                        _vm._v(" "),
                        _c("radio-button-row", {
                          key: _vm.radioButtonKey,
                          staticClass: "mb-4",
                          attrs: {
                            title:
                              "ContinuousReportSummary.Collaboration.CustomerGuidance.TotalsCorrect",
                            required: true
                          },
                          model: {
                            value: _vm.guidanceTotalsCorrect,
                            callback: function($$v) {
                              _vm.guidanceTotalsCorrect = $$v
                            },
                            expression: "guidanceTotalsCorrect"
                          }
                        }),
                        _vm._v(" "),
                        _vm.guidanceTotalsCorrect === false
                          ? _c("customer-guidance-tables-control", {
                              attrs: {
                                totals:
                                  _vm.collaboration.customerGuidanceSummary
                                    .revisedTotals,
                                isRevisionTable: "",
                                title:
                                  "ContinuousReportSummary.Collaboration.CustomerGuidance.RevisedTotals"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("text-area-with-notes-control", {
                          attrs: {
                            id: "resultsDescription",
                            title:
                              "ContinuousReportSummary.Collaboration.CustomerGuidance.ResultsDescription",
                            required: "",
                            notes: _vm.notesReference,
                            "max-length": 500,
                            rows: 5,
                            buttonTooltip:
                              "ContinuousReportSummary.Collaboration.CustomerGuidance.ResultsDescription_NotesTooltip"
                          },
                          model: {
                            value:
                              _vm.collaboration.customerGuidanceSummary
                                .resultsDescription,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.collaboration.customerGuidanceSummary,
                                "resultsDescription",
                                $$v
                              )
                            },
                            expression:
                              "collaboration.customerGuidanceSummary.resultsDescription"
                          }
                        })
                      ]
                ]
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }